// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"06039edc","131":"0f1cd131","166":"e4706e7c","310":"2aef7328","326":"d458d74e","824":"eded6f18","941":"2f82d114","953":"80ee6266"}[chunkId] + ".chunk.js";
};